<script>
  export let product
  export let selectedProduct
  export let durationAbbr
  export let monthlyPrice
  export let onSale
  export let originalMonthlyPrice

  function specialOffer(duration) {
    if (duration) {
      switch (duration.toLowerCase()) {
        case "quarterly":
          return "4th Month FREE<br>+ FREE Shipping"
        case "annual":
          return "12th Month FREE<br>+ FREE Shipping<br>+ FREE Lock Box"
        default:
          return ""
      }
    }
  }
</script>

<tr
  selected={selectedProduct == product}
  class:active={selectedProduct == product}
  on:click={() => (selectedProduct = product)}
>
  <td>
    <input
      type="radio"
      class="styled-checkbox"
      bind:group={selectedProduct}
      value={product}
    />
  </td>
  <td>
    <span class="plan capitalize">
      {product.price_duration}
    </span>
  </td>
  <td>
    <span class="cost">
      {#if onSale}
        <span class="line-through text-red-secondary block italic"
          >${parseFloat(product.original_price).toFixed(2)} /{durationAbbr}</span
        >
      {/if}
      {@html product.display_price} /{durationAbbr}
    </span>
  </td>
  <td>
    <span class="per-month">
      {#if onSale}
        <span class="line-through text-red-secondary block italic"
          >${originalMonthlyPrice} /mo</span
        >
      {/if}
      ${monthlyPrice} /mo
    </span>
  </td>
  <td>
    <span class="offer">
      {@html specialOffer(product.price_duration)}
    </span>
  </td>
</tr>
